/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_SituationInputs */

const en_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const de_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const fr_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const es_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const it_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const nl_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const pl_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const fi_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const da_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

const sv_story_bank_label_situation = /** @type {(inputs: Story_Bank_Label_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situation`)
};

/**
* | output |
* | --- |
* | "Situation" |
*
* @param {Story_Bank_Label_SituationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_situation = /** @type {((inputs?: Story_Bank_Label_SituationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_SituationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_situation(inputs)
	if (locale === "fr") return fr_story_bank_label_situation(inputs)
	if (locale === "es") return es_story_bank_label_situation(inputs)
	if (locale === "it") return it_story_bank_label_situation(inputs)
	if (locale === "nl") return nl_story_bank_label_situation(inputs)
	if (locale === "pl") return pl_story_bank_label_situation(inputs)
	if (locale === "fi") return fi_story_bank_label_situation(inputs)
	if (locale === "da") return da_story_bank_label_situation(inputs)
	if (locale === "sv") return sv_story_bank_label_situation(inputs)
	return en_story_bank_label_situation(inputs)
});